import gql from 'graphql-tag'
export default gql`mutation createPlantMutation($plant: BasePlant!) {
  createPlant(plant: $plant) {
    name
    id
  }
}`